// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  key: __t.string().primaryKey(),
  epoch: __t.u32(),
  settlementId: __t.u64().name("settlement_id"),
  identity: __t.identity(),
  seconds: __t.u32(),
  lastPingAt: __t.timestamp().name("last_ping_at"),
  keepsake: __t.bool(),
});
